module.exports = __webpack_public_path__ + "static/media/b_3bhk_7.dfa5e9d1.jpg";